import React from "react";
import "./loaderAnimation.css";

var LoaderAnimation = class LoaderAnimation extends React.Component{
  constructor(props) {
      super(props);
  }  
  
  render() {


      return (
        <div className = 'loadingAnimation'>
            <div className="loaderContainer">
                <div className="loadingLine"></div>
                <div className="loadingText">{this.props.text}</div>
                <div className="rearLoadingLine"></div>
            </div>
        </div>
      );
    }
  }

export default LoaderAnimation;


// WEBPACK FOOTER //
// ./src/components/loaderAnimation/loaderAnimation.js